/* Startseite, Runde 5 (Versuch 05.10.2026) – Konzept „hello.“. Ergänzt assets/cm-x-home.js, ändert es nicht.
   1 Karte „Reparatur am selben Tag“ im Kopf zeigt dieselbe Live-Zeile wie der Tagesplan weiter unten
     ([data-cmx-h-same], gefüllt von cm-x-home.js) – gespiegelt, damit die Regeln nur an EINER Stelle stehen.
   2 Knopf „Noch einmal“: spielt das „hello.“ erneut (Klasse .cmx-r5-hello an <html> kurz weg und wieder dran).
   3 Kapitel-Auftritt: Kapitelzeile, Titel und Satz jedes Kapitels steigen EINMAL gestaffelt auf, sobald sie ins Bild
     kommen; der Handschrift-Strich unter der Kapitelzeile zieht sich dabei. Ohne Skript / „Bewegung reduzieren“: alles
     steht sofort da. Keine Anfragen ans Netz. Rückweg: startseite-versuch/ZURUECK.sh 20. */
(function () {
  'use strict';
  var root = document.querySelector('.cmx-r5');
  var doc = document.documentElement;
  if (!root) { doc.classList.remove('cmx-r5-js'); return; }
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;
  var safe = function (f) { try { f(); } catch (e) { /* Seite bleibt, wie sie ohne Skript ist */ } };

  function sameDay() {
    var src = root.querySelector('[data-cmx-h-same]'), dst = root.querySelector('[data-cmx-r5-same]');
    if (!src || !dst) return;
    var copy = function () { var t = (src.textContent || '').trim(); if (t && dst.textContent !== t) dst.textContent = t; };
    copy();
    if ('MutationObserver' in window) new MutationObserver(copy).observe(src, { childList: true, characterData: true, subtree: true });
  }

  function replay() {
    var b = root.querySelector('[data-cmx-r5-replay]');
    if (!b || reduce) return;
    b.hidden = false;
    b.addEventListener('click', function () {
      doc.classList.remove('cmx-r5-hello');
      void root.offsetWidth;
      doc.classList.add('cmx-r5-hello');
    });
  }

  function reveal() {
    if (reduce || !('IntersectionObserver' in window)) { doc.classList.remove('cmx-r5-js'); return; }
    var sel = '[data-cmx-r5-in], .cmx-h-kicker, .cmx-h-head > h2, .cmx-h-head > .cmx-h-head-text, .cmx-h-people-copy > h2, .cmx-h-finale-card > h2';
    var els = Array.prototype.filter.call(root.querySelectorAll(sel), function (el) { return !el.closest('.cmx-r5-hero'); });
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) { el.classList.add('is-in'); }       // schon im Bild: nichts verstecken
      el.setAttribute('data-cmx-r5-in', '');
      var sib = 0, p = el.previousElementSibling;
      while (p) { if (els.indexOf(p) >= 0) sib++; p = p.previousElementSibling; }
      el.style.transitionDelay = Math.min(sib, 3) * 90 + 'ms';
      if (!el.classList.contains('is-in')) io.observe(el);
    });
  }

  safe(sameDay); safe(replay); safe(reveal);
  doc.classList.add('cmx-r5-ready');
})();

/* Pro Display XDR im Kopf (06.10.2026): neigt sich leicht zur Maus. Nur mit feiner Maus, nicht bei „Bewegung reduzieren“. */
(() => {
  const dev = document.querySelector('[data-cmx-xdr]');
  const hero = document.querySelector('[data-cmx-r5-hero]');
  if (!dev || !hero || !matchMedia('(pointer: fine)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const fig = dev.parentElement;
  let raf = 0;
  hero.addEventListener('pointermove', (e) => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      const r = dev.getBoundingClientRect();
      const x = (e.clientX - (r.left + r.width / 2)) / (window.innerWidth / 2);
      const y = (e.clientY - (r.top + r.height / 2)) / (window.innerHeight / 2);
      fig.style.setProperty('--xdr-ry', `${Math.max(-1, Math.min(1, x)) * 5}deg`);
      fig.style.setProperty('--xdr-rx', `${Math.max(-1, Math.min(1, y)) * -3.5}deg`);
    });
  }, { passive: true });
  hero.addEventListener('pointerleave', () => { fig.style.setProperty('--xdr-ry', '0deg'); fig.style.setProperty('--xdr-rx', '0deg'); });
})();
